import { render } from "./bookFlight.vue?vue&type=template&id=3b215fb9&scoped=true"
import script from "./bookFlight.vue?vue&type=script&lang=js"
export * from "./bookFlight.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./bookFlight.vue?vue&type=style&index=1&id=3b215fb9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b215fb9"]])

export default __exports__